import { useEffect, useState } from "react";
import axios from "axios";
import Slogo from "../assets/bizflowl-small-logo.png";
import { NotificationManager } from "react-notifications";
import { useParams } from "react-router-dom";
import dateFormat from "dateformat";
import { getSession } from '../services/api';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Link,
  PDFViewer,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFF",
    color: "black",
  },
  appLogo: {
    width: 70,
    position: "absolute",
    bottom: 15,
    right: 5,
  },
  Text: {
    width: "100%",
  },
  section: {
    margin: 10,
    padding: 10,
  },
  bottom: {
    position: "absolute",
    left: 0,
    right: 0,
    textAlign: "right",
  },
  address4: {
    width: "24%",
  },
  line: {
    width: "80%",
    borderBottomColor: "#666666",
    borderBottomWidth: 3,
  },
  containerHead: {
    flexDirection: "row",
    borderBottomColor: "#666666",
    backgroundColor: "#666666",
    borderBottomWidth: 1,
    color: "#FFFFFF",
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  container: {
    flexDirection: "row",
    borderBottomColor: "#000",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  containerBottom: {
    flexDirection: "row",
    alignItems: "center",
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  containerBottomPI: {
    flexDirection: "row",
    alignItems: "center",
    textAlign: "left",
    flexGrow: 1,
  },
  toCapital: {
    textTransform: "capitalize",
  },
  viewer: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  logo: {
    width: 70,
    marginLeft: 250,
  },
  customerName: {
    fontSize: 12,
    textAlign: "left",
    fontWeight: 900,
  },
  customerNameOther: {
    fontSize: 8,
    textAlign: "left",
    fontWeight: 900,
  },
  text: {
    fontSize: 8,
    textAlign: "center",
  },
  Srno: { width: "10%", fontSize: 9, fontWeight: 700, textAlign: "center" },
  Description: {
    width: "40%",
    fontSize: 9,
    fontWeight: 700,
    textAlign: "left",
    textTransform: "capitalize",
  },
  smallDescription: {
    fontSize: 7,
    fontWeight: 500,
    textAlign: "left",
    textTransform: "capitalize",
  },
  qty: { width: "5%", fontSize: 9, fontWeight: 700, textAlign: "center" },
  tax: { width: "8%", fontSize: 9, fontWeight: 700, textAlign: "center" },
  uprice: { width: "23%", fontSize: 9, fontWeight: 700, textAlign: "right" },
  make: { width: "18%", fontSize: 9, fontWeight: 700, textAlign: "right" },
  tprice: { width: "23%", fontSize: 9, fontWeight: 700, textAlign: "right" },
  gTotal: {
    borderBottomColor: "#000000",
    borderBottomWidth: 2,
    borderTopWidth: 1,
    borderTopColor: "#000000",
    width: "23%",
    fontSize: 11,
    fontWeight: 900,
    textAlign: "right",
  },
  date: {
    fontSize: 8,
    textAlign: "right",
  },

  // style for PI
  SrnoPI: { width: "10%", fontSize: 9, fontWeight: 700, textAlign: "center" },
  DescriptionPI: {
    width: "40%",
    fontSize: 9,
    fontWeight: 700,
    textAlign: "left",
    textTransform: "capitalize",
  },
  topBarPI: {
    flexDirection: "row",
    fontStyle: "bold",
    flexGrow: 1,
  },
  customerNameOtherPI: {
    fontSize: 8,
    textAlign: "left",
    fontWeight: 900,
    width: "50%",
    paddingRight: 50,
  },
  BoldText: {
    fontSize: 12,
    fontWeight: 900,
    textAlign: "right",
    width: "40%",
    backgroundColor: "#666666",
    color: "#FFFFFF",
    padding: 10,
  },
  whitePI: {
    width: "10%",
  },
  titlePI: {
    fontWeight: "bold",
    fontSize: 12,
    width: "50%",
    padding: 10,
    textAlign: "left",
    backgroundColor: "#666666",
    color: "#FFFFFF",
  },
  smallDescriptionPI: {
    fontSize: 7,
    fontWeight: 500,
    textTransform: "capitalize",
  },
  smallDescriptionRPI: {
    fontSize: 7,
    fontWeight: 500,
    textAlign: "right",
    textTransform: "capitalize",
  },
  qtyPI: { width: "5%", fontSize: 9, fontWeight: 700, textAlign: "center" },
  DescriptionINVPI: { width: "35%", fontSize: 9, fontWeight: 700, textAlign: "left" },
  upricePI: { width: "15%", fontSize: 9, fontWeight: 700, textAlign: "right" },
  tpricePI: { width: "20%", fontSize: 9, fontWeight: 700, textAlign: "right" },
  gTotalPI: {
    borderBottomColor: "#000000",
    borderBottomWidth: 2,
    borderTopWidth: 1,
    borderTopColor: "#000000",
    width: "20%",
    fontSize: 11,
    fontWeight: 900,
    textAlign: "right",
  },
});

var converter = require('number-to-words');

const EMPTY_PDF_DATA = {
  corporate: { business: "", address: "", phone: "", email: "", website: "", gst: "" },
  customer: { id: "", company: "", street: "", city: "", number: "", email: "" },
  quote: { status: null, date_entered: null, pono: "", withtax: 0, comment: "" },
  address: {},
  bank: [],
  addresses: [],
  salesPerson: { name: "", designation: "", phone: "" },
  products: [],
};

function QuotePDF() {
  const [pdfData, setPdfData] = useState(EMPTY_PDF_DATA);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  const { id } = useParams();
  const session = getSession();

  const getProduct = {
    corp_id: session.corp_id,
    quote_id: id,
    user_id: session.user_id,
    module: "grabForPDF",
    product: "quotationB",
  };

  async function AxiosPDF(formData) {
    NotificationManager.info("please wait...");
    setLoading(true);
    setLoadError('');
    try {
      const res = await axios({
        method: "post",
        url: "https://www.bestwebdealers.com/reactManager/",
        data: formData,
      });
      if (res.data && res.data.data && res.data.data[0]) {
        const d = res.data.data[0];
        // Guard against missing arrays/objects from the API response
        setPdfData({
          ...EMPTY_PDF_DATA,
          ...d,
          corporate: d.corporate || EMPTY_PDF_DATA.corporate,
          customer: d.customer || EMPTY_PDF_DATA.customer,
          quote: d.quote || EMPTY_PDF_DATA.quote,
          salesPerson: d.salesPerson || EMPTY_PDF_DATA.salesPerson,
          bank: Array.isArray(d.bank) ? d.bank : [],
          addresses: Array.isArray(d.addresses) ? d.addresses : [],
          products: Array.isArray(d.products) ? d.products : [],
        });
      } else {
        setLoadError('No data returned for this quote.');
      }
    } catch (ex) {
      console.error(ex);
      setLoadError('Failed to load PDF data.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    AxiosPDF(getProduct);
  }, [id]);

  if (loading) {
    return <div style={{ padding: 20 }}>Loading PDF…</div>;
  }

  if (loadError) {
    return <div style={{ padding: 20, color: 'red' }}>{loadError}</div>;
  }

  

  // Reset totals on every render (was module-level before — caused accumulation bugs)
  let ttl = 0;
  let tax = 0;

  return (
    <div>
      <PDFViewer style={styles.viewer}>
        <Document>
          <Page size="A4" style={styles.page}>
            <View style={styles.section}>
              <View style={styles.topBarPI}>
                <Text style={styles.titlePI}>
                  {pdfData.corporate.business}
                  {'\n'}
                  <Text style={styles.smallDescriptionPI}>
                    {pdfData.corporate.address}
                    {'\n\n'}
                    Phone: {pdfData.corporate.phone} {'\n'}
                    Email: {pdfData.corporate.email}{'\n'}
                    Website: {pdfData.corporate.website}{'\n'}
                    GST No.: {pdfData.corporate.gst}
                  </Text>
                </Text>
                <Text style={styles.whitePI}></Text>
                <Text style={styles.BoldText}>PROFORMA INVOICE
                  <Text style={styles.smallDescriptionRPI}>{'\n\n'}
                    Date: {pdfData.quote.date_entered ? dateFormat(pdfData.quote.date_entered, "dd mmm, yyyy") : ''}{'\n'}
                    {(pdfData.quote.pono) ? "PO NO.: " + pdfData.quote.pono + "\n" : ""}
                    Customer ID: {'CS' + pdfData.customer.id}{'\n'}{'\n'}{'\n'}{'\n'}
                    NOTE: This PI is valid for 15 days only.
                  </Text>
                </Text>
              </View>
              <Text>{"\n"}</Text>

              <View style={styles.topBarPI}>
                <Text style={styles.customerNameOtherPI}>
                  <Text style={styles.customerName}>
                    CUSTOMER {'\n\n'}
                  </Text>
                  Company: {pdfData.customer.company + '\n'}
                  Address: {(pdfData.customer.street || '') + ", " + (pdfData.customer.city || '')}{'\n'}
                  Phone: {pdfData.customer.number}{'\n'}
                  Email: {pdfData.customer.email}{'\n'}
                </Text>

                <Text style={styles.customerNameOtherPI}>
                  <Text style={styles.customerName}>
                    SHIPPING ADDRESS{'\n\n'}
                  </Text>
                  Company: {pdfData.customer.company + '\n'}
                  Address: {(pdfData.customer.street || '') + ", " + (pdfData.customer.city || '')}{'\n'}
                  Phone: {pdfData.customer.number}{'\n'}
                  Email: {pdfData.customer.email}{'\n'}
                </Text>
              </View>
              <Text>&nbsp;</Text>

              <View style={styles.containerHead}>
                <Text style={styles.SrnoPI}>PART NO.</Text>
                <Text style={styles.Description}>DESCRIPTION</Text>
                {pdfData.quote.withtax == 1 ?
                  <Text style={styles.tax}>Tax</Text> : <></>}
                <Text style={styles.qtyPI}>MAKE</Text>
                <Text style={styles.qtyPI}>QTY</Text>
                <Text style={styles.upricePI}>UNIT PRICE </Text>
                <Text style={styles.tpricePI}>TOTAL PRICE</Text>
              </View>

              {pdfData.products.map((pros, index) => {
                const prott = (pros.qty * pros.price);
                ttl += prott;
                if (pdfData.quote.withtax == 1) {
                  tax += (prott * pros.tax) / 100;
                }
                const proddescription = pros.pro_description
                  ? "(" + pros.pro_description + ")"
                  : "";
                return (
                  <View key={index} style={styles.container}>
                    <Text style={styles.SrnoPI}>{index + 1}</Text>
                    <Text style={styles.Description}>
                      {pros.product_name} - {pros.sku}{" "}
                      <Text style={styles.smallDescriptionPI}>
                        {proddescription}
                      </Text>
                    </Text>
                    {pdfData.quote.withtax == 1 ?
                      <Text style={styles.tax}>{pros.tax}%</Text> : <></>}
                    <Text style={styles.qtyPI}>{pros.manufacture}</Text>
                    <Text style={styles.qtyPI}>{pros.qty}</Text>
                    <Text style={styles.upricePI}> {pros.price}</Text>
                    <Text style={styles.tpricePI}>
                      {(prott).toFixed(2)}
                    </Text>
                  </View>
                );
              })}

              <View style={styles.containerBottom}>
                <Text style={styles.SrnoPI}></Text>
                <Text style={styles.DescriptionINVPI}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.tax}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.upricePI}>Total </Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.tpricePI}>{ttl.toFixed(2)}</Text>
              </View>

              {pdfData.quote.withtax == 1 ? (
                <View style={styles.containerBottom}>
                  <Text style={styles.SrnoPI}></Text>
                  <Text style={styles.DescriptionINVPI}></Text>
                  <Text style={styles.qtyPI}></Text>
                  <Text style={styles.qtyPI}></Text>
                  <Text style={styles.tax}></Text>
                  <Text style={styles.qtyPI}></Text>
                  <Text style={styles.upricePI}>Gst Tax</Text>
                  <Text style={styles.qtyPI}></Text>
                  <Text style={styles.tpricePI}>
                    {(tax).toFixed(2)}
                  </Text>
                </View>
              ) : <></>}

              <View style={styles.containerBottom}>
                <Text style={styles.SrnoPI}></Text>
                <Text style={styles.DescriptionINVPI}></Text>
                <Text style={styles.qty}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.tax}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.upricePI}>Grand Total</Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.gTotalPI}>
                  {(ttl + tax).toFixed(0) + '.00'}
                </Text>
              </View>

              <View>
                <Text style={styles.SrnoPI}></Text>
                <Text style={styles.DescriptionINVPI}>
                  TERMS AND CONDITIONS{"\n"}
                  {pdfData.quote.comment}
                </Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.upricePI}></Text>
                <Text style={styles.tpricePI}></Text>
              </View>

              <View style={styles.containerHead}>
                <Text style={styles.DescriptionINVPI}> ADDITIONAL DETAILS</Text>
              </View>

              <View style={styles.containerBottom}>
                <Text style={styles.SrnoPI}></Text>
                <Text style={styles.customerNameOther}>
                  {pdfData.bank.map((bnks, index) => (
                    <Text key={index}>{bnks.branch + "\n" + bnks.Detail + "\n\n"}</Text>
                  ))}
                </Text>
              </View>

              <View style={styles.containerBottomPI}>
                <Text style={styles.SrnoPI}>{'\n'}</Text>
              </View>

              <View style={styles.containerBottomPI}>
                <Text style={styles.customerNameOther}>AMOUNT IN WORDS:--
                  <Text style={styles.toCapital}>
                    {'\n' + converter.toWords(Number((ttl + tax).toFixed(0)) || 0)} only
                  </Text>
                </Text>
              </View>

              <View style={styles.containerBottomPI}>
                <Text style={styles.customerNameOther}>{'\n\n'}I certify the above to be true and correct to the best of my knowledge.</Text>
              </View>

              <View style={styles.containerBottom}>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.upricePI}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.tpricePI}></Text>
              </View>

              <View style={styles.containerBottom}>
                <Text style={styles.DescriptionINVPI}>
                  {pdfData.salesPerson.name} {"\n"}{pdfData.salesPerson.designation},
                  {"\n"}
                  {pdfData.salesPerson.phone}
                </Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.uprice}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.tprice}></Text>
              </View>

              <View style={styles.containerBottom}>
                <Text style={styles.DescriptionINVPI}>
                  For {pdfData.corporate.business}
                </Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.uprice}></Text>
                <Text style={styles.qtyPI}></Text>
                <Text style={styles.tprice}></Text>
              </View>

              <Text></Text>
              <Text></Text>
              <Text></Text>
              <Text></Text>
              <Text style={styles.Description}></Text>
            </View>

            <View>
              <Text>{"\n"}</Text>
            </View>
            <View>
              <Text>{"\n"}</Text>
            </View>
            <View style={styles.container}></View>

            <View fixed>
              {pdfData.addresses.map((addres, index) => (
                <Text key={index} style={styles.text}>{addres.office + ": " + addres.address}</Text>
              ))}
              <Text>&nbsp;</Text>
              <Text>&nbsp;</Text>
              <Link src="https://www.bizflowsuite.com/">
                <Image src={Slogo} style={styles.appLogo} />
              </Link>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
}

export default QuotePDF;
